import React, { useState } from 'react';
import Menu from './Menu';
import './navbar.css';

export default function NavSmall() {

    const [open, setOpen] = useState(false);

    const handleToggle = () => {
        setOpen(!open)
    };

    return (
        <nav className="navbar navbar-expand-lg navbar-light fixed-top nav--small nav_small_screen animate__animated animate__slideInDown">
            <div className="container-fluid mt-4 nav--container">
                <a className="nav--brand" href="#Cover">David Piredda</a>
                <button onClick={handleToggle} className="p-3 me-4 border-0 rounded-4 bg-transparent" type="button">
                    <span className="navbar-toggler-icon"></span>
                </button>
            </div>
            {open ? <Menu handleToggle={handleToggle}/> : null}
        </nav>
    )
}
